import { ComponentPropsWithRef, FC, PropsWithChildren } from 'react'

import clsx from 'clsx'

type ButtonProps = ComponentPropsWithRef<'button'>
type Props = ButtonProps & {
  bgColor: 'dark' | 'white'
}
export const ActionButton: FC<PropsWithChildren<Props>> = ({
  bgColor,
  children,
  type,
  className,
  ...otherProps
}) => {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={clsx(
        'tw-outline-none tw-transition-[0.2s] tw-border-b-border-primary tw-py-s1 tw-font-bold',
        bgColor === 'dark'
          ? 'tw-text-inlineText-primary tw-bg-roovPrimary-default hover:tw-bg-roovPrimary-activePressed tw-border-none'
          : 'tw-text-standardText-primary tw-bg-surface-primary hover:tw-bg-surface-secondary',
        className
      )}
      {...otherProps}
    >
      {children}
    </button>
  )
}
